export default __webpack_public_path__ + "static/tab-img09-dc94cd376347cc01a5aaaa8340515c56.png";